/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CategoryDto,
  CategoryOverviewDtoFilterSortSearchPagedRequestDto,
  CategoryOverviewDtoPagedResponseDto,
  CategoryTreeNodeExtendedDto,
  CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto,
  EntityNotFoundErrorDetailsErrorResponseModel,
  GetSpendingRequestDto,
  InvalidPropertyValueErrorDetailsErrorResponseModel,
  LookupItemDto,
  SpendingDto,
} from '../models/index';
import {
    CategoryDtoFromJSON,
    CategoryDtoToJSON,
    CategoryOverviewDtoFilterSortSearchPagedRequestDtoFromJSON,
    CategoryOverviewDtoFilterSortSearchPagedRequestDtoToJSON,
    CategoryOverviewDtoPagedResponseDtoFromJSON,
    CategoryOverviewDtoPagedResponseDtoToJSON,
    CategoryTreeNodeExtendedDtoFromJSON,
    CategoryTreeNodeExtendedDtoToJSON,
    CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSON,
    CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSON,
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    GetSpendingRequestDtoFromJSON,
    GetSpendingRequestDtoToJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelFromJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelToJSON,
    LookupItemDtoFromJSON,
    LookupItemDtoToJSON,
    SpendingDtoFromJSON,
    SpendingDtoToJSON,
} from '../models/index';

export interface CategoriesGetCategoriesOverviewPOSTRequest {
    categoryOverviewDtoFilterSortSearchPagedRequestDto?: CategoryOverviewDtoFilterSortSearchPagedRequestDto;
}

export interface CategoriesGetCategoriesTreeOverviewPOSTRequest {
    categoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto?: CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto;
}

export interface CategoriesGetCategoryBusinessUnitsSpendingPOSTRequest {
    getSpendingRequestDto?: GetSpendingRequestDto;
}

export interface CategoriesGetCategoryByIdGETRequest {
    id: string;
}

export interface CategoriesGetCategoryCompanySpendingPOSTRequest {
    getSpendingRequestDto?: GetSpendingRequestDto;
}

/**
 * CategoriesApi - interface
 * 
 * @export
 * @interface CategoriesApiInterface
 */
export interface CategoriesApiInterface {
    /**
     * Creates request options for categoriesGetCategoriesOverviewPOST without sending the request
     * @param {CategoryOverviewDtoFilterSortSearchPagedRequestDto} [categoryOverviewDtoFilterSortSearchPagedRequestDto] 
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoriesOverviewPOSTRequestOpts(requestParameters: CategoriesGetCategoriesOverviewPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CategoryOverviewDtoFilterSortSearchPagedRequestDto} [categoryOverviewDtoFilterSortSearchPagedRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoriesOverviewPOSTRaw(requestParameters: CategoriesGetCategoriesOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryOverviewDtoPagedResponseDto>>;

    /**
     */
    categoriesGetCategoriesOverviewPOST(requestParameters: CategoriesGetCategoriesOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryOverviewDtoPagedResponseDto>;

    /**
     * Creates request options for categoriesGetCategoriesTreeOverviewPOST without sending the request
     * @param {CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto} [categoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto] 
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoriesTreeOverviewPOSTRequestOpts(requestParameters: CategoriesGetCategoriesTreeOverviewPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto} [categoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoriesTreeOverviewPOSTRaw(requestParameters: CategoriesGetCategoriesTreeOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryTreeNodeExtendedDto>>;

    /**
     */
    categoriesGetCategoriesTreeOverviewPOST(requestParameters: CategoriesGetCategoriesTreeOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryTreeNodeExtendedDto>;

    /**
     * Creates request options for categoriesGetCategoryBusinessUnitsSpendingPOST without sending the request
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryBusinessUnitsSpendingPOSTRequestOpts(requestParameters: CategoriesGetCategoryBusinessUnitsSpendingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryBusinessUnitsSpendingPOSTRaw(requestParameters: CategoriesGetCategoryBusinessUnitsSpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>>;

    /**
     */
    categoriesGetCategoryBusinessUnitsSpendingPOST(requestParameters: CategoriesGetCategoryBusinessUnitsSpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>>;

    /**
     * Creates request options for categoriesGetCategoryByIdGET without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryByIdGETRequestOpts(requestParameters: CategoriesGetCategoryByIdGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryByIdGETRaw(requestParameters: CategoriesGetCategoryByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryDto>>;

    /**
     */
    categoriesGetCategoryByIdGET(requestParameters: CategoriesGetCategoryByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryDto>;

    /**
     * Creates request options for categoriesGetCategoryCompanySpendingPOST without sending the request
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryCompanySpendingPOSTRequestOpts(requestParameters: CategoriesGetCategoryCompanySpendingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryCompanySpendingPOSTRaw(requestParameters: CategoriesGetCategoryCompanySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>>;

    /**
     */
    categoriesGetCategoryCompanySpendingPOST(requestParameters: CategoriesGetCategoryCompanySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>>;

    /**
     * Creates request options for categoriesGetCategoryLookupGET without sending the request
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryLookupGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApiInterface
     */
    categoriesGetCategoryLookupGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LookupItemDto>>>;

    /**
     */
    categoriesGetCategoryLookupGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LookupItemDto>>;

}

/**
 * 
 */
export class CategoriesApi extends runtime.BaseAPI implements CategoriesApiInterface {

    /**
     * Creates request options for categoriesGetCategoriesOverviewPOST without sending the request
     */
    async categoriesGetCategoriesOverviewPOSTRequestOpts(requestParameters: CategoriesGetCategoriesOverviewPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Categories/overview`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CategoryOverviewDtoFilterSortSearchPagedRequestDtoToJSON(requestParameters['categoryOverviewDtoFilterSortSearchPagedRequestDto']),
        };
    }

    /**
     */
    async categoriesGetCategoriesOverviewPOSTRaw(requestParameters: CategoriesGetCategoriesOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryOverviewDtoPagedResponseDto>> {
        const requestOptions = await this.categoriesGetCategoriesOverviewPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategoryOverviewDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async categoriesGetCategoriesOverviewPOST(requestParameters: CategoriesGetCategoriesOverviewPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryOverviewDtoPagedResponseDto> {
        const response = await this.categoriesGetCategoriesOverviewPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategoriesTreeOverviewPOST without sending the request
     */
    async categoriesGetCategoriesTreeOverviewPOSTRequestOpts(requestParameters: CategoriesGetCategoriesTreeOverviewPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Categories/overview-tree`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CategoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSON(requestParameters['categoryTreeNodeExtendedDtoFilterSortSearchPagedRequestDto']),
        };
    }

    /**
     */
    async categoriesGetCategoriesTreeOverviewPOSTRaw(requestParameters: CategoriesGetCategoriesTreeOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryTreeNodeExtendedDto>> {
        const requestOptions = await this.categoriesGetCategoriesTreeOverviewPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategoryTreeNodeExtendedDtoFromJSON(jsonValue));
    }

    /**
     */
    async categoriesGetCategoriesTreeOverviewPOST(requestParameters: CategoriesGetCategoriesTreeOverviewPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryTreeNodeExtendedDto> {
        const response = await this.categoriesGetCategoriesTreeOverviewPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategoryBusinessUnitsSpendingPOST without sending the request
     */
    async categoriesGetCategoryBusinessUnitsSpendingPOSTRequestOpts(requestParameters: CategoriesGetCategoryBusinessUnitsSpendingPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Categories/business-unit-spending`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSpendingRequestDtoToJSON(requestParameters['getSpendingRequestDto']),
        };
    }

    /**
     */
    async categoriesGetCategoryBusinessUnitsSpendingPOSTRaw(requestParameters: CategoriesGetCategoryBusinessUnitsSpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>> {
        const requestOptions = await this.categoriesGetCategoryBusinessUnitsSpendingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpendingDtoFromJSON));
    }

    /**
     */
    async categoriesGetCategoryBusinessUnitsSpendingPOST(requestParameters: CategoriesGetCategoryBusinessUnitsSpendingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>> {
        const response = await this.categoriesGetCategoryBusinessUnitsSpendingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategoryByIdGET without sending the request
     */
    async categoriesGetCategoryByIdGETRequestOpts(requestParameters: CategoriesGetCategoryByIdGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling categoriesGetCategoryByIdGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Categories/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async categoriesGetCategoryByIdGETRaw(requestParameters: CategoriesGetCategoryByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryDto>> {
        const requestOptions = await this.categoriesGetCategoryByIdGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategoryDtoFromJSON(jsonValue));
    }

    /**
     */
    async categoriesGetCategoryByIdGET(requestParameters: CategoriesGetCategoryByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryDto> {
        const response = await this.categoriesGetCategoryByIdGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategoryCompanySpendingPOST without sending the request
     */
    async categoriesGetCategoryCompanySpendingPOSTRequestOpts(requestParameters: CategoriesGetCategoryCompanySpendingPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Categories/company-spending`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSpendingRequestDtoToJSON(requestParameters['getSpendingRequestDto']),
        };
    }

    /**
     */
    async categoriesGetCategoryCompanySpendingPOSTRaw(requestParameters: CategoriesGetCategoryCompanySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>> {
        const requestOptions = await this.categoriesGetCategoryCompanySpendingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpendingDtoFromJSON));
    }

    /**
     */
    async categoriesGetCategoryCompanySpendingPOST(requestParameters: CategoriesGetCategoryCompanySpendingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>> {
        const response = await this.categoriesGetCategoryCompanySpendingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategoryLookupGET without sending the request
     */
    async categoriesGetCategoryLookupGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Categories/lookup`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async categoriesGetCategoryLookupGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LookupItemDto>>> {
        const requestOptions = await this.categoriesGetCategoryLookupGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemDtoFromJSON));
    }

    /**
     */
    async categoriesGetCategoryLookupGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LookupItemDto>> {
        const response = await this.categoriesGetCategoryLookupGETRaw(initOverrides);
        return await response.value();
    }

}
